import { WEB_CHAT_WIDGET_LANGUAGE_APPLIED } from '@/lib/analytics-events';
import { trackWidgetEvent } from '../utils/analytics';
import { getNavigatorLanguages, resolveWidgetLocale } from './resolve-locale';

let trackedThisLoad = false;

/**
 * Track the resolved widget language once per page load, after analytics init.
 */
export function trackWidgetLanguageApplied(institutionId: string): void {
  if (trackedThisLoad) return;
  trackedThisLoad = true;

  const { locale, browserLanguage, isFallback } = resolveWidgetLocale(
    getNavigatorLanguages()
  );

  trackWidgetEvent(WEB_CHAT_WIDGET_LANGUAGE_APPLIED, {
    browser_language: browserLanguage,
    applied_language: locale,
    is_fallback: isFallback,
    institution_id: institutionId,
  });
}

/** Test-only: allow re-tracking after `vi.resetModules()`-style isolation. */
export function resetWidgetLanguageAppliedTrackingForTests(): void {
  trackedThisLoad = false;
}
